<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useProductGroupList } from '@/models/product-group'

  defineProps<{
    label?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const { getData, loading, productGroups } = useProductGroupList()
  getData({ search: undefined, per_page: 100000 })

  const selectedGroup = computed({
    get: () => route.query.group,
    set: (value) => updateRoute({ group: value }),
  })
</script>

<template>
  <app-select
    v-model="selectedGroup"
    :label="label ?? 'Grup Produk'"
    :loading="loading">
    <option :value="undefined">
      Semua
    </option>
    <option
      v-for="group in productGroups"
      :key="group.id"
      :value="group.id">
      {{ group.name }}
    </option>
  </app-select>
</template>
